import { format } from "date-fns";

export const dayFormatter = (isoString) => {
    const defaultFormat = 'MMMM d'
    const today = new Date();
    const date = new Date(isoString);

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
        return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
        return 'Yesterday';
    } else {
        return format(date, defaultFormat);
    }
}
